<template>
  <div>
    Successful application of the equations of equilibrium requires a complete specification of all the known and unknown external forces that act on
    the body. The best way to account for these forces is to draw a free-body diagram. This diagram is a sketch of the outlined shape of the body,
    which represents it as being isolated or "free" from its surroundings, i.e., a "free body." On this sketch it is necessary to show all the forces
    and couple moments that the surroundings exert on the body so that these effects can be accounted for when the equations of equilibrium are
    applied.
    <ul>
      <li>If a support prevents the translation of a body in a given direction, then a force is developed on the body in that direction.</li>
      <li>If rotation is prevented, a couple moment is exerted on the body.</li>
    </ul>
  </div>
</template>
<script>
export default { name: "FBD_text" };
</script>
